import React from "react";
import PropTypes from "prop-types";
import ListView from "./ListView";
import { formatMoney } from "accounting";
import ChangeQuantity from "./ChangeQuantity";

const PurchasedProductsList = ({ purchasedProducts, children }) => {
  return (
    <ListView items={purchasedProducts}>
      {purchasedProduct => (
        <div className="row product-list-item">
          <div className="col-auto">
            <img
              className="image"
              src={`${process.env.REACT_APP_API_URL}${purchasedProduct.image_url}`}
              alt={purchasedProduct.name_product}
            />
          </div>
          <div className="col">
            <div className="row">
              <div className="col">
                <p className="product-name">{purchasedProduct.name_product}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-sm">
                <p className="product-price">
                  {formatMoney(purchasedProduct.price_product)}
                </p>
              </div>
              <div className="col-12 col-sm">
                <ChangeQuantity
                  itemId={purchasedProduct.id}
                  quantity={purchasedProduct.quantity}
                />
              </div>
              <div className="col-12 col-sm">
                <p className="product-price product-total">
                  {formatMoney(purchasedProduct.cost)}
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-auto">
            {typeof children === "function"
              ? children({ purchasedProduct })
              : children}
          </div>
        </div>
      )}
    </ListView>
  );
};

PurchasedProductsList.propTypes = {
  purchasedProducts: PropTypes.array.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.func.isRequired,
    PropTypes.element.isRequired
  ])
};

export default PurchasedProductsList;
